/* @flow strict */

/* eslint-disable camelcase */

import * as React from 'react';

import _ from 'lodash';
import DataTable from 'react-data-table-component';
import { FBpagesTablecolumns } from './header';

const customStyles = {
  headCells: {
    style: {
      fontWeight: 700,
      fontSize: '1rem'
    }
  },
  tableWrapper: {
    style: {
      display: 'block',
      overflow: 'scroll'
    }
  },
  table: {
    style: {
      display: 'table'
    }
  }
};
const conditionalRowStyles = [
  {
    when: row => row.has_added_app,
    style: {
      backgroundColor: '#dcecfa !important'
    }
  }
];

export const FBpagesTable = ({ data, embed, uninstall }: {data: [], embed: () => void, uninstall: () => void}): any => {
  return (
    <DataTable
      className='FBpagesTable dataTable'
      columns={FBpagesTablecolumns(embed, uninstall)}
      data={data}
      conditionalRowStyles={conditionalRowStyles}
      customStyles={customStyles}
      defaultSortField="name"
      highlightOnHover
      pointerOnHover
      pagination={_.size(data) > 100}
      paginationPerPage={100}
      paginationRowsPerPageOptions={[100, 500, 1000]}
      responsive
      striped
      fixedHeader
      noHeader
      sortIcon={(): React.Element<typeof React.Fragment> => {
        return (
          <>
            <span className="-sort-desc" />
            <span className="-sort-asc" />
          </>
        );
      }}
      // progressPending={progressPending}
      // progressComponent={<CustomLoader />}
    />
  );
};
